import React, { FC } from 'react';
import { graphql } from 'gatsby';

import DangerouslySetInnerHtml from 'common/DangerouslySetInnerHtml';
import useScreenRecognition from 'hooks/useScreenRecognition';
import GatsbyImage from 'common/GatsbyImage';

import { ISplitBannerProps } from './model';

import './SplitBanner.scss';

const SplitBanner: FC<ISplitBannerProps> = ({
  bannerContent,
  desktopImage,
  mobileImage,
}) => {
      const { isMobile, isDesktop, isTablet } = useScreenRecognition();

      return (
    <>
  <section>
    <div className="split-banner__container">
      <DangerouslySetInnerHtml className="split-banner__content" html={bannerContent} />
      {isDesktop || isTablet && desktopImage?.[0]?.properties?.image ? (
        <div className="split-banner__desktop-image">
          <GatsbyImage
            className="text-with-image__middle-image"
            image={desktopImage?.[0]?.properties?.image}
            alt={desktopImage?.[0]?.properties?.imageAlt}
            isLazyLoading={false}
            objectFit="cover"
          />
        </div>
      ) : null}
      {isMobile && mobileImage?.[0]?.properties?.image ? (
        <div className="split-banner__mobile-image">
          <GatsbyImage
            className="text-with-image__middle-image"
            image={mobileImage?.[0]?.properties?.image}
            alt={mobileImage?.[0]?.properties?.imageAlt}
            isLazyLoading={false}
            objectFit="cover"
          />
        </div>
      ) : null}
    </div>
  </section>
  </>
);
}

export const query = graphql`
  fragment FragmentSplitBanner on TSplitBanner {
    properties {
      bannerContent
      desktopImage {
        properties {
          image {
            ...FragmentGatsbyProps
            gatsbyImage {
              childImageSharp {
                fluid(maxWidth: 1200) {
                  ...GatsbyImageSharpFluid_withWebp
                }
              }
            }
          }
          imageAlt
        }
      }
        mobileImage {
        properties {
          image {
            ...FragmentGatsbyProps
            gatsbyImage {
              childImageSharp {
                fluid(maxWidth: 1200) {
                  ...GatsbyImageSharpFluid_withWebp
                }
              }
            }
          }
          imageAlt
        }
      }
    }
    structure
  }
`;

export default SplitBanner;
